export * from './defaultTranslations';
export { TEAM_NAME } from '../constants-generated';

export const APP_NAME = 'loyalty-dialog';
export const PACKAGE_NAME = '@ori/loyalty-dialog';

export const EMOTION_CACHE_KEY = `${APP_NAME}-emotion-cache-key`;
